// src/pages/BlogDetail.js
import React, { useEffect, useState } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';

const blogTypeLabels = {
  0: 'None',
  1: 'Essay',
  2: 'News',
  4: 'Report',
};

const BlogDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const passedEntry = location.state?.entry;

  const [entry, setEntry] = useState(passedEntry || null);
  const [htmlContent, setHtmlContent] = useState('');
  const [comments, setComments] = useState([]);

  // Load blog entry from API only if it wasn't passed in
  useEffect(() => {
    if (!entry) {
      fetch('https://affeerce-backend.onrender.com/api/blogEntries')
        .then(res => res.json())
        .then(data => {
          const found = data.find(e => String(e.Id) === id);
          if (found) setEntry(found);
        });
    }
  }, [entry, id]);

  // Load blob and comments once entry is set
  useEffect(() => {
    if (!entry) return;

    fetch(`https://elsieresources.blob.core.windows.net/blogentries/${entry.Blob}`)
      .then(res => res.text())
      .then(setHtmlContent)
      .catch(err => {
        console.error("Failed to load blog HTML:", err);
        setHtmlContent('<p>Error loading content.</p>');
      });

    fetch(`https://affeerce-backend.onrender.com/api/comments/${id}`)
      .then(res => res.json())
      .then(setComments)
      .catch(() => setComments([]));
  }, [entry, id]);

  if (!entry) return <p>Loading blog entry...</p>;

  return (
    <div className="blog-container">
      <Link to="/blog" className="back-link">← Back to Blog</Link>
      <h2>{entry.Title}</h2>
      <div className="blog-detail-meta">
  <p><strong>By:</strong> {entry.AuthorName}</p>
  <p><strong>Type:</strong> {blogTypeLabels[entry.BlogType]}</p>
  <p><strong>Date:</strong> {new Date(entry.CreatedAt).toLocaleDateString()}</p>
</div>

      <div className="blog-html-wrapper">
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div>

      <div className="comments-section">
        <h3>Comments</h3>
        {comments.length === 0 ? (
          <p>No comments yet.</p>
        ) : (
          comments.map((c, idx) => (
            <div key={idx} className="comment-card">
              <p><strong>{c.AuthorName || 'Anonymous'}</strong> – {new Date(c.CreatedAt).toLocaleDateString()}</p>
              <p>{c.Comment}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BlogDetail;
